import styled from 'styled-components';
export { Caption } from 'styles';

export const Container = styled.div`
  width: 100%;
  max-width: 1036px;
  margin-bottom: 88px;

  @media screen and (max-width: 500px) {
    margin-bottom: 56px;
  }
`;

export const ImageWrapper = styled.div`
  img {
    width: 100%;
  }
`;
